import S from './VehiclesScoreWidgetStyles';
import EntityRating from '../common/EntityRating/EntityRating';
import { createCSV, downloadFile } from '../../utils/commonUtils';
import Icon from '../common/Icon/Icon';
import { IconKeys } from '../common/Icon/IconKeys';
import { VehicleDetails } from '../../API/types/Vehicles';
import { TimePeriod } from '../../constants/TimePeriod';

const PERIOD_TO_SCORE_FIELD: Record<string, 'score' | 'scoreDaily' | 'scoreWeekly' | 'scoreMonthly'> = {
  daily: 'scoreDaily',
  weekly: 'scoreWeekly',
  monthly: 'scoreMonthly',
};

type Props = Readonly<{
  fleetId: string;
  groupFilters?: Record<string, any>;
  reportName?: string;
  averageScore?: number | null;
  period?: string;
  allVehicles?: VehicleDetails[];
}>;

function VehiclesScoreWidget({
  reportName, averageScore, period = 'all', allVehicles = [],
}: Props): JSX.Element {
  const scoreField = PERIOD_TO_SCORE_FIELD[period] ?? 'score';
  const scoreDisplay = averageScore != null ? Math.round(averageScore) : null;
  const periodLabel = (TimePeriod as any)[period] ?? TimePeriod.all;

  const withScore = allVehicles.filter((v) => {
    const s = v[scoreField] as number | null;
    return s != null && s > 0;
  });
  const sorted = [...withScore].sort((a, b) => {
    const sa = (a[scoreField] as number) ?? 0;
    const sb = (b[scoreField] as number) ?? 0;
    return sb - sa;
  });
  const topVehicles = sorted.slice(0, 3);
  const lowVehicles = [...sorted].reverse().slice(0, 3);

  return (
    <S.Wrapper>
      <button
        className="report-btn"
        title="Create report"
        type="button"
        onClick={() => {
          downloadFile(createCSV([...topVehicles, ...lowVehicles] as Record<string, any>[]), `${reportName}_widgets`, 'text/csv');
        }}
      >
        <Icon iconKey={IconKeys.SUMMARIZE} />
      </button>
      <EntityRating
        title={`Top vehicle scores • ${periodLabel}`}
        entities={topVehicles}
        ratingField={scoreField}
        entityType="vehicle"
        isLoading={false}
      />
      <div className="horizont-line" />
      <EntityRating
        title={`Lowest vehicle scores • ${periodLabel}`}
        entities={lowVehicles}
        ratingField={scoreField}
        entityType="vehicle"
        isLoading={false}
      />
      <div className={`average-score${scoreDisplay === null ? ' no-score' : ''}`}>
        <div className="title">Average vehicles score</div>
        <div className="score">{scoreDisplay ?? 'N/A'}</div>
      </div>
    </S.Wrapper>
  );
}

export default VehiclesScoreWidget;
